"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxDoNotDisturbSettingsArgs = void 0;
var HxPauseSetting_1 = require("./HxPauseSetting");
var HxDailySetting_1 = require("./HxDailySetting");
function serializeHxDoNotDisturbSettingsArgs(_arg) {
    var output = [];
    output.push(_arg.enabledDuringEvents);
    output.push(_arg.eventSettingLastModifiedTimeUtc !== undefined);
    if (_arg.eventSettingLastModifiedTimeUtc !== undefined) {
        output.push(_arg.eventSettingLastModifiedTimeUtc.valueOf());
    }
    var pauseSettingsOutput = [];
    _arg.pauseSettings.forEach(function (item) { return pauseSettingsOutput.push(HxPauseSetting_1.serializeHxPauseSetting(item)); });
    output.push(pauseSettingsOutput);
    var dailySettingsOutput = [];
    _arg.dailySettings.forEach(function (item) { return dailySettingsOutput.push(HxDailySetting_1.serializeHxDailySetting(item)); });
    output.push(dailySettingsOutput);
    output.push(_arg.endTimeMode);
    output.push(_arg.endTimeUtc !== undefined);
    if (_arg.endTimeUtc !== undefined) {
        output.push(_arg.endTimeUtc.valueOf());
    }
    return output;
}
exports.serializeHxDoNotDisturbSettingsArgs = serializeHxDoNotDisturbSettingsArgs;
